// utils
import * as v from "valibot";

// domain
import {
	allowedPrimaryStatsBySlot,
	gimoSetStatNames,
} from "#/domain/GIMOStatNames";
import { CharacterStatsSchema, TargetStatsSchema } from "./index";

const PrimaryStatRestrictionsSchema = v.object({
	arrow: v.optional(v.picklist(allowedPrimaryStatsBySlot.arrow)),
	triangle: v.optional(v.picklist(allowedPrimaryStatsBySlot.triangle)),
	circle: v.optional(v.picklist(allowedPrimaryStatsBySlot.circle)),
	cross: v.optional(v.picklist(allowedPrimaryStatsBySlot.cross)),
});

const PrimaryStatRestrictionsSchemaV26 = v.object({
	arrow: v.optional(v.array(v.picklist(allowedPrimaryStatsBySlot.arrow))),
	triangle: v.optional(v.array(v.picklist(allowedPrimaryStatsBySlot.triangle))),
	circle: v.optional(v.array(v.picklist(allowedPrimaryStatsBySlot.circle))),
	cross: v.optional(v.array(v.picklist(allowedPrimaryStatsBySlot.cross))),
});

const GIMOSetStatNamesSchema = v.picklist(gimoSetStatNames);
const SetRestrictionsSchema = v.record(GIMOSetStatNamesSchema, v.number());

const OptimizationPlanSchema = v.object({
	id: v.string(),
	description: v.string(),
	Health: v.number(),
	Protection: v.number(),
	Speed: v.number(),
	"Critical Damage %": v.number(),
	"Potency %": v.number(),
	"Tenacity %": v.number(),
	"Physical Damage": v.number(),
	"Special Damage": v.number(),
	"Critical Chance": v.number(),
	Armor: v.number(),
	Resistance: v.number(),
	"Accuracy %": v.number(),
	"Critical Avoidance %": v.number(),
	targetStats: TargetStatsSchema,
	minimumModDots: v.number(),
	primaryStatRestrictions: PrimaryStatRestrictionsSchema,
	setRestrictions: SetRestrictionsSchema,
	useOnlyFullSets: v.boolean(),
});

const OptimizationPlanSchemaV26 = v.object({
	id: v.string(),
	description: v.string(),
	Health: v.number(),
	Protection: v.number(),
	Speed: v.number(),
	"Critical Damage %": v.number(),
	"Potency %": v.number(),
	"Tenacity %": v.number(),
	"Physical Damage": v.number(),
	"Special Damage": v.number(),
	"Critical Chance": v.number(),
	Armor: v.number(),
	Resistance: v.number(),
	"Accuracy %": v.number(),
	"Critical Avoidance %": v.number(),
	targetStats: TargetStatsSchema,
	minimumModDots: v.number(),
	primaryStatRestrictions: PrimaryStatRestrictionsSchemaV26,
	setRestrictions: SetRestrictionsSchema,
	useOnlyFullSets: v.boolean(),
});

const OptimizationPlanSchemaV31 = v.object({
	id: v.string(),
	description: v.string(),
	Health: v.number(),
	Protection: v.number(),
	Speed: v.number(),
	"Critical Damage %": v.number(),
	"Potency %": v.number(),
	"Tenacity %": v.number(),
	"Physical Damage": v.number(),
	"Special Damage": v.number(),
	"Critical Chance": v.number(),
	Armor: v.number(),
	Resistance: v.number(),
	"Accuracy %": v.number(),
	"Critical Avoidance %": v.number(),
	targetStats: TargetStatsSchema,
	minimumModDots: v.number(),
	primaryStatRestrictions: PrimaryStatRestrictionsSchemaV26,
	setRestrictions: SetRestrictionsSchema,
	useOnlyFullSets: v.boolean(),
	simulatedRelicLevel: v.number(),
	simulatedStats: v.nullable(CharacterStatsSchema),
});

export {
	OptimizationPlanSchema,
	OptimizationPlanSchemaV26,
	OptimizationPlanSchemaV31,
};
